import React from 'react'
import Sidenav from '../components/Sidenav'
import UpdateProduct from '../components/products/UpdateProduct'

export default function Updateproducts() {
  return (
<div className="flex flex-1 ">
       <div className="">
       <Sidenav />
       </div>
        <div className="">
            <UpdateProduct />
        </div>
    </div>    )
}
